@if (treeNodeService) {
  <div class="tree-container">
    <div class="action-buttons" [class.blocked]="loading">
      <ng-content select="[buttons]"></ng-content>
      <app-tree-header-buttons [treeNodeService]="treeNodeService"></app-tree-header-buttons>
    </div>
    <div class="tree">
      <ng-content select="[customNode]"></ng-content>
      @if (rootNode) {
        <app-tree-node
          [data]="{ node: rootNode, treeNodeService: treeNodeService }"
        ></app-tree-node>
      } @else {
        <app-skeleton></app-skeleton>
      }
    </div>
  </div>
}
